import { Input, InputGroup, Select } from '@sgcmpteltd/uikit-react';
import {
  MENU_BORDER_RADIUS_LARGE,
  MENU_CONTAINER_POSITION_BOTTOM,
  MENU_CONTAINER_POSITION_TOP,
  SELECT_SIZE_SM,
} from '@sgcmpteltd/uikit-react/components/select';
import cx from 'clsx';
import type { ChangeEventHandler } from 'react';
import { useMemo } from 'react';

import {
  SELECT_MENU_CLOSE_DELAY_MSEC,
} from '../../../../../app/(routes)/listing/_components/page-content/constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Choice: Component = ({
  name,
  selectOption,
  inputOption,
  optionValue,
  inputValue,
  isLast,
  onChange,
}) => {
  const handleSelectChange = (v: string | number) => {
    const option = selectOption.optionList.find(opt => opt.value === v);

    selectOption.onChange?.(v);

    onChange?.({
      name,
      type: 'choice',
      optionValue: {
        text: option?.text || '',
        value: option?.value || '',
      },
      unit: {
        type: Object.hasOwn(inputOption, 'prefix')
          ? 'prefix'
          : 'suffix',
        value: Object.hasOwn(inputOption, 'prefix')
          ? inputOption.prefix?.toString() ?? ''
          : inputOption.suffix?.toString() ?? '',
      },
      inputValue,
    });
  };

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const option = selectOption.optionList
      .find(opt => opt.value === optionValue.value);

    onChange?.({
      name,
      type: 'choice',
      optionValue: {
        text: option?.text || '',
        value: option?.value || '',
      },
      inputValue: e.target.value,
      unit: {
        type: Object.hasOwn(inputOption, 'prefix')
          ? 'prefix'
          : 'suffix',
        value: Object.hasOwn(inputOption, 'prefix')
          ? inputOption.prefix?.toString() ?? ''
          : inputOption.suffix?.toString() ?? '',
      },
    });
  };

  const isDisabled = useMemo(
    () => selectOption.optionList.findIndex(
      opt => opt.value === optionValue.value,
    ) === -1,
    [optionValue.value, selectOption.optionList],
  );

  return (
    <div className={styles.containerRoot}>
      <div className={styles.containerSelect}>
        <Select
          headerClassName={cx(
            styles.selectRoot,
            styles.containerSelectHead,
            optionValue.value ? styles.activeSelect : '',
          )}
          menuBorderRadius={MENU_BORDER_RADIUS_LARGE}
          menuCloseDelayMsec={SELECT_MENU_CLOSE_DELAY_MSEC}
          menuPosition={
            isLast
              ? MENU_CONTAINER_POSITION_TOP
              : MENU_CONTAINER_POSITION_BOTTOM
          }
          optionList={selectOption.optionList}
          placeholder={selectOption.placeholder}
          size={SELECT_SIZE_SM}
          value={optionValue.value}
          onChange={handleSelectChange} />
      </div>
      <div className={styles.containerInputGroup}>
        <InputGroup
          className={cx(
            styles.inputGroup,
            styles.isRound,
            styles.isSmall,
          )}
          isDisabled={isDisabled}
          prefix={inputOption.prefix}
          prefixContainerClassName={cx(
            styles.prefixContainerClassName,
            styles.prefixPadding,
            styles.prefixIcon,
          )}
          suffix={inputOption.suffix}
          suffixContainerClassName={cx(
            styles.suffixContainerClassName,
            styles.suffixPadding,
            styles.suffixIcon,
          )}>
          <Input
            className={cx(
              styles.containerInput,
              inputOption.prefix && styles.prefix,
              inputOption.suffix && styles.suffix,
            )}
            disabled={isDisabled}
            type={inputOption.type}
            value={inputValue}
            isBorderless
            onChange={handleInputChange} />
        </InputGroup>
      </div>
    </div>
  );
};
